{
  "fr": {
    "aiPersona": {
      "confirm": {
        "deleteConversation": {
          "text": "Cette action est irréversible. La conversation sera définitivement supprimée avec tous les messages.",
          "title": "Supprimer la conversation ?"
        }
      },
      "defaults": {
        "description": "Discutez avec un chatbot qui incarne le rôle de {name}."
      },
      "disclaimer": "Ce chat utilise une intelligence artificielle (IA). Les réponses sont fictives. L'IA tente toutefois de se faire passer pour la personne concernée. Essayez, posez des questions, mais restez critique et effectuez éventuellement des vérifications de faits. Amusez‑vous bien !",
      "emptyState": {
        "title": "Quel rôle votre chatbot doit‑il jouer ?",
        "description": "Choisissez un rôle : saisissez le nom d’une figure historique ou fictive et lancez le jeu de rôle.",
        "hint": "<strong>N'oubliez pas votre propre intelligence :</strong> L'IA peut sembler humaine, mais c’est une machine. Remettez toujours les réponses en question de façon critique.",
        "createButton": "Créer un nouveau rôle"
      },
      "deprecationAlert": {
        "title": "Attention : cette zone est en cours de réaménagement !",
        "description": "Pour éviter les malentendus avec l'IA, il n’y a plus de rôles pré‑définis ici. Vous pouvez toutefois continuer à créer des chatbots avec des rôles personnalisés.",
        "hint": "Astuce : dans le Catalogue d'assistants IA, vous trouverez une large sélection d’assistants IA sélectionnés et de chatbots à rôles prêts à l’emploi.",
        "catalogLink": "Voir le catalogue d’assistants IA"
      },
      "historyAlert": {
        "title": "Attention : cette zone sera bientôt déplacée !",
        "description": "À l’avenir, vous trouverez toutes les conversations passées uniquement dans le chat IA et pourrez y créer de nouveaux chatbots.",
        "chatLink": "Aller au Chat IA"
      },
      "flash": {
        "nameNotPermitted": "Ce rôle ne peut pas être créé."
      },
      "labels": {
        "name": "Nom du rôle"
      },
      "links": {
        "myAssistants": "Mes assistants et chatbots",
        "newPersona": "Créer un nouveau rôle"
      },
      "categories": {
        "my": "Mes assistants"
      },
      "personaForm": {
        "heading": "Définissez le rôle du chatbot",
        "create": "Créer"
      }
    }
  }
}
